export default "__VITE_ASSET__9CamNAtA__"